module.exports = __webpack_public_path__ + "img/cacahuetes.769fbe20.svg";